import React from "react";

function FieldWrapper({ label = "", id = "", required = false, showIcon = true, children }) {
  return (
    <div>
      <label htmlFor="dept" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">
        {label} {required && <span className="text-[red] pl-0.2">*</span>}
      </label>

      <div className="relative">
        {showIcon && <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>}
        {children}
      </div>
    </div>
  );
}

export default FieldWrapper;
